module.exports = __webpack_public_path__ + "static/media/qd_monthly-report-5.d4219c1b.png";